import styled from '@emotion/styled';
import { TableCell } from '@mui/material';
import { Link } from 'react-router-dom';
import Theme from 'App.theme';
import { TableContainer } from 'components/Table/Table';

export const SetPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  scroll-behavior: smooth;

  a {
    color: ${Theme.colours.black};
    text-decoration: none;
    border-bottom: 2px solid #fff;
    transition: border-bottom 0.3s;

    &:hover {
      border-bottom: 2px solid ${Theme.colours.black};
    }
  }
`;

export const SetHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;

  h1 {
    margin: 0;
  }
`;

export const SerialListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;

  h1 {
    margin: 0;
  }
`;

export const SetLinksList = styled.div`
  display: flex;
  margin-bottom: 1rem;
  gap: 1rem;
`;

export const SetLink = styled.a`
  font-weight: bold;
`;

export const SetButtons = styled.div`
  .MuiButtonBase-root {
    font-size: 14px;
    width: 10rem;
    margin-left: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;

export const SetBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const SetRow = styled.div`
  display: flex;
  gap: 1rem;
`;

export const DropTableContainer = styled(TableContainer)`
  max-height: 100%;
`;

export const DropTableWrapper = styled.div`
  position: absolute;
  top: 60px;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(115, 115, 115, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContent = styled.div`
  background-color: white;
  padding: 24px 40px;
`;

export const CustomLink = styled(Link)`
  text-decoration: none;
`;

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  max-width: 80%;
  padding: 20px;
  margin: 0 auto;
`;

export const Table = styled.div`
  border: 1px solid ${Theme.greys.GREY1};
  border-radius: 0.5rem;
  overflow: hidden;
`;

export const Container = styled(TableContainer)`
  max-height: 600px;
`;

export const HeadTableCell = styled(TableCell)`
  background-color: ${Theme.greys.GREY1};
`;

export const FileUploadButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-top: 1rem;
`;

export const FileUploadListItemIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 0.5rem;
`;

export const FileUploadFilterBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 0 0 1rem 0;
`;

export const FileUploadFilterSearchContainer = styled.div`
  width: 50%;
`;

export const FileUploadFilterDropdownsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 50%;
  justify-content: end;
  align-items: center;
`;
